import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { MetricsClient, metricsApiRef } from './api/MetricsClient';
import { alarmsRouteRef, entityAlarmsRouteRef, rootRouteRef } from './routes';

export const metricsPlugin = createPlugin({
  id: 'metrics',
  apis: [
    createApiFactory({
      api: metricsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new MetricsClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
    alarms: alarmsRouteRef,
    entityAlarms: entityAlarmsRouteRef,
  },
});

export const EntityMetricsContent = metricsPlugin.provide(
  createRoutableExtension({
    name: 'EntityMetricsContent',
    component: () =>
      import('./components/MetricsPage/MetricsPage').then(m => m.MetricsPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityAlarmsContent = metricsPlugin.provide(
  createRoutableExtension({
    name: 'EntityAlarmsContent',
    component: () =>
      import('./components/Alarms/EntityAlarmsContent').then(
        m => m.EntityAlarmsContent,
      ),
    mountPoint: entityAlarmsRouteRef,
  }),
);

export const AlarmsPage = metricsPlugin.provide(
  createRoutableExtension({
    name: 'AlarmsPage',
    component: () =>
      import('./components/Alarms/AlarmsPage').then(m => m.AlarmsPage),
    mountPoint: alarmsRouteRef,
  }),
);
